/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Update_Marker_ButtonInputs */

const en_markers_update_marker_button = /** @type {(inputs: Markers_Update_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Marker`)
};

const fr_markers_update_marker_button = /** @type {(inputs: Markers_Update_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre a jour le marqueur`)
};

const de_markers_update_marker_button = /** @type {(inputs: Markers_Update_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisierungsmarkierung`)
};

const it_markers_update_marker_button = /** @type {(inputs: Markers_Update_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna marcatore`)
};

const ru_markers_update_marker_button = /** @type {(inputs: Markers_Update_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить маркер`)
};

const es_markers_update_marker_button = /** @type {(inputs: Markers_Update_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar marcador`)
};

const zh_cn2_markers_update_marker_button = /** @type {(inputs: Markers_Update_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新标记`)
};

const ja_markers_update_marker_button = /** @type {(inputs: Markers_Update_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新マーカー`)
};

const hi_markers_update_marker_button = /** @type {(inputs: Markers_Update_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्कर अपडेट करें`)
};

const pt_pt2_markers_update_marker_button = /** @type {(inputs: Markers_Update_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar marcador`)
};

/**
* | output |
* | --- |
* | "Update Marker" |
*
* @param {Markers_Update_Marker_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_update_marker_button = /** @type {((inputs?: Markers_Update_Marker_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Update_Marker_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_update_marker_button(inputs)
	if (locale === "de") return de_markers_update_marker_button(inputs)
	if (locale === "it") return it_markers_update_marker_button(inputs)
	if (locale === "ru") return ru_markers_update_marker_button(inputs)
	if (locale === "es") return es_markers_update_marker_button(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_update_marker_button(inputs)
	if (locale === "ja") return ja_markers_update_marker_button(inputs)
	if (locale === "hi") return hi_markers_update_marker_button(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_update_marker_button(inputs)
	return en_markers_update_marker_button(inputs)
});